export const MORE_DETAILS_LINK = 'more-details-link';
export const MORE_DETAILS_HREF = '/privacy';
export const COOKIE_DASHBOARD_LINK = 'cookie-dashboard-link';
export const COOKIE_DASHBOARD_HREF = '/cookie-richtlinie';
